import { List } from 'immutable';

import config from '../config';
import { toPounds } from '../helpers/Currency';

/**
 *  See https://developers.google.com/tag-manager/enhanced-ecommerce
 *  and https://developers.google.com/analytics/devguides/collection/analyticsjs/enhanced-ecommerce
 *  and https://www.simoahava.com/analytics/enhanced-ecommerce-guide-for-google-tag-manager/
 */

const EcommerceHelper = {
    wrapper (data) {
        return {
            ecommerce: data
        };
    },

    purchase (order) {
        const products = order.trips.reduce(
            (p, trip) => p.concat(this.productsFromTrip(trip))
            , new List());

        return this.wrapper({
            'purchase': {
                'actionField': {
                    'id': order.id,
                    'affiliation': config.get('brand'),
                    'revenue': toPounds(order.totalPrice),
                    'tax': 0,
                    'shipping': toPounds(order.delivery.price),
                },
                products: products.toJS()
            }
        });
    },

    getTocs(fare) {
        const journeys = [ fare.outwardJourney, fare.returnJourney ];
        const tocs = [];

        journeys.map(journey => {
            if (journey) {
                journey.legs.map(({ toc }) => {
                    if (toc && tocs.indexOf(toc.name) === -1) {
                        tocs.push(toc.name);
                    }
                });
            }
        });

        return tocs.sort().join(', ');
    },

    productFromTicket (fare, ticket) {
        const { adults, children, railcard, price } = ticket;
        const { origin, destination, route, ticketType, restrictionCode, crossLondon, discountCode, returnJourney } = fare;
        const { isReturn, isSeason, isAdvance, isPackage, isFirstClass, validityCode } = ticketType;
        const id = [ origin.nlc, destination.nlc, route.code, ticketType.code ].join('-');
        const name = [ ticketType.name, origin.name, destination.name, route.description ].join(' - ');
        const category = ticketType.name;
        const originCodeName = [ origin.nlc, origin.name ].join(' - ');
        const destinationCodeName = [ destination.nlc, destination.name ].join(' - ');
        const routeCodeName = [ route.code, route.name ].join(' - ');

        let product = {
            id,
            name,
            price: toPounds(price),
            quantity: adults || children,
            variant: children ? 'child' : 'adult',
            brand: this.getTocs(fare),
            category,
            dimension6: originCodeName,
            dimension7: destinationCodeName,
            dimension8: routeCodeName,
            dimension9: isReturn,
            dimension10: isSeason,
            dimension11: isAdvance,
            dimension12: isPackage,
            dimension13: isFirstClass,
            dimension14: validityCode,
            dimension15: restrictionCode || 'none',
            dimension16: crossLondon,
            dimension17: discountCode || 'none',
            dimension18: fare.getDepartureTime() ? fare.getDepartureTime().format('YYYY-MM-DDTHH:mm:ss') : 'none',
            dimension19: (returnJourney && returnJourney.getDepartureTime()) ? returnJourney.getDepartureTime().format('YYYY-MM-DDTHH:mm:ss') : 'none',
        };

        if (railcard) {
            product.coupon = railcard.name;
        }

        return product;
    },

    productsFromTrip (orderTrip) {
        const fares = orderTrip.getProducts();
        const products = fares.map((fare) => fare.tickets.map((ticket) => {
            const data = this.productFromTicket(fare, ticket);
            return fare.isFlexi() ? Object.assign(data, { quantity: 1 }) : data;
        })).flatten(1).toJS();
        return products;
    },

    addToBasket (orderTrip) {
        return this.wrapper({
            currencyCode: 'GBP',
            'add': {
                products: this.productsFromTrip(orderTrip)
            }
        });
    },

    orderStarted (id) {
        return this.wrapper({
            'checkout': {
                'id': id,
                'actionField': {'step': 1, 'option': 'order-started'}
            }
        });
    },

    deliveryPage (id) {
        return this.wrapper({
            'checkout': {
                'id': id,
                'actionField': {'step': 2}
            }
        });
    },

    deliveryMethod (id, deliveryMethod) {
        return this.wrapper({
            'checkout_option': {
                'id': id,
                'actionField': {'step': 2, 'option': deliveryMethod}
            }
        });
    },

    paymentPage (id) {
        return this.wrapper({
            'checkout': {
                'id': id,
                'actionField': {'step': 3}
            }
        });
    },

    paymentMethod (id, paymentMethod) {
        return this.wrapper({
            'checkout_option': {
                'id': id,
                'actionField': {'step': 3, 'option': paymentMethod}
            }
        });
    },

    removeFromBasket (orderTrip) {
        return this.wrapper({
            'remove': {
                products: this.productsFromTrip(orderTrip)
            }
        });
    }
};

export default EcommerceHelper;



// WEBPACK FOOTER //
// ./src/helpers/DataLayerEcommerce.js